import { Router, RouterModule } from '@angular/router';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  output,
  inject,
  input,
} from '@angular/core';
import { PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { BehaviorSubject } from 'rxjs';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { ClientService } from '@fitness-force/api';
import { ClientStatus } from '@fitness-force/enum';
@Component({
  selector: 'prospect-info',
  templateUrl: './prospect-info.component.html',
  styleUrls: ['./prospect-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PopoverModule,
    AvatarModule,
    ShortNamePipe,
    RouterModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class ProspectInfoComponent {
  private readonly router = inject(Router);
  private readonly clientService = inject(ClientService);

  // Angular 21: Use signal input with BehaviorSubject for Observable compatibility
  readonly columnData = input<BehaviorSubject<any>>(new BehaviorSubject(null));

  readonly onAction = output<{ action: string; columnData: any }>();

  gotoClient(id: any) {
    this.router.navigate(['/client/profile/', id]);
  }

  clientStatus(client: any): string {
    if (client?.client_status)
      return this.clientService.getClientStatusHtml(
        client.client_status.toString(),
      );
    else return '';
  }
  clientStatusOther(client: any): string {
    if (client && (client.clt_status || client.clt_status))
      return this.clientService.getClientStatusHtml(
        ClientStatus[client.clt_status as keyof typeof ClientStatus].toString(),
      );
    else return '';
  }

  isEmptyAndNull(obj: any) {
    if (!obj) return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false;
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData });
  }
}
